/**
 * propertyType
 * proposedPropertyType
 */
export const selectOptionsPropertyType = [
  "SFR",
  "2-unit",
  "3-unit",
  "4-unit",
  "5-unit",
  "6-unit",
  "7-unit",
  "8-unit",
  "Condo",
  "Townhome",
  "Planned Unit Development (PUD)",
  "Multifamily",
  "Mixed-Use",
  "Commercial",
  "Undeveloped Land",
  "Other",
  "Non-Warrantable Condo",
];
